module.exports = __webpack_public_path__ + "media/images/ic-mail-cinza-621a6fc01d15eba20ac56b3277c90870.svg";